import HeroSection from "../components/heroSection";
import {useEffect} from "react";
import FreeMonthForm from "../components/forms/freeMonthForm";
import FooterView from "../components/footerView";
import TestimonialView from "../components/testimonials/testimonialView";
import DescriptionWithLogos from "../components/descriptionWithLogos";
import EasyCheckout from "../components/home/easyCheckout";
import ThreeCardSelection from "../components/home/threeCardSelection";
import SecondHero from "../components/home/secondHero";

function Home() {

    useEffect(() => {
        // Check for hash in the URL
        const hash = window.location.hash;
        console.log('Hash detected:', hash);

        if (hash) {
            const target = document.querySelector(hash);
            if (target) {
                // Open the details block if it's not open
                const details = target.closest('free-seo');
                if (details) {
                    details.open = true;
                }
                // Smoothly scroll to the target, adjusted by 50 pixels
                const targetPosition = target.getBoundingClientRect().top + window.scrollY - 70;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }, []);


    return (
        <div className="App" style={{
        }}>
            <div className="">
                <HeroSection />
                <DescriptionWithLogos/>
                <EasyCheckout />
                <ThreeCardSelection />


                <div className="">
                    <TestimonialView />
                </div>

                <div className="">
                    <SecondHero />
                </div>
                <div id="free-seo" className="">
                    <FreeMonthForm />
                </div>



                <FooterView />
            </div>
        </div>
    );
}

export default Home;
